import React from "react";
import { ReactComponent as CloseIcon } from "../../../assets/images/icons/close.svg";

interface Props extends React.PropsWithChildren {
  title?: string;
  titleClassName?: string;
  state: [any, React.Dispatch<any>];
  hiddenCloseButton?: boolean;
  onClose?: () => void;
  width?: string;
  locked?: boolean;
}

const Modal: React.FC<Props> = (props: Props) => {
  const {
    title,
    titleClassName,
    state: [modalOpen, setModalOpen],
    hiddenCloseButton = false,
    onClose,
    children,
    width = "auto",
    locked = false,
  } = props;

  const closeModal = () => {
    setModalOpen(false);
    onClose && onClose();
  };

  return (
    modalOpen && (
      <div
        className="bg-black-transparent modal overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 block lg:flex justify-center w-full md:inset-0 h-max lg:h-full max-h-full lg:p-0 px-1 py-4"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))" }}
      >
        <div
          className="relative p-0 max-h-full flex flex-col justify-center items-center w-auto lg:w-[1300px]"
        >
          <div
            className="relative bg-white w-full"
            style={{ boxShadow: "rgba(0, 0, 0, 0.25) 0px 5px 15px" }}
          >
            {!hiddenCloseButton && (
              <div
                className="absolute top-0 right-0 my-4 mx-4 lg:my-6 cursor-pointer"
                onClick={closeModal}
              >
                <CloseIcon className="stroke-black w-8 h-8" />
              </div>
            )}
            <div className="p-4 md:p-8">
              <div className="modal-header lg:mb-3 mb-7">
                {title && (
                  <h3 className={`${titleClassName} pr-12`}>{title}</h3>
                )}
              </div>
              <div className="modal-body text-grey-dark">{children}</div>
            </div>
          </div>
        </div>
        {locked && (
          <div className="absolute top-0 left-0 w-full h-full bg-white opacity-15 z-auto transition-opacity"></div>
        )}
      </div>
    )
  );
};

export default Modal;
